<template>
  <div
    class="Tool"
    :style="{
      'width': Tool_Size.width+'px',
      'height': Tool_Size.height+'px',
      'left': MaterialPane_Size.width+'px'
    }"
    :class="{
      'autoDraw' : autoDraw,
  }"
  >
    <editorBtn />
    <Editor :class="{'format-painter-active': brushCursor}" />
    <Textbox  />
    <richText></richText>
    <Timeline :class="{'format-painter-active': brushCursor}" :style="{opacity: openSubtitle ? 0 : 1}"></Timeline>
    <spriteBtn></spriteBtn>
    <toolMask></toolMask>
    <bgSettingBtn></bgSettingBtn>
    <auxiliaryLine></auxiliaryLine>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Editor from "./tool/editor.vue"; // 画布
import Textbox from "./tool/textbox.vue"; // 文本框
import richText from "./tool/richTextEdit.vue"; // 富文本框
import Timeline from "./tool/timeline.vue"; // 时间轴
import editorBtn from "./tool/editorBtn.vue"; // 编辑器按钮
import spriteBtn from "./tool/spriteBtn.vue"; // 元素的帮助按钮
import toolMask from "./tool/mask.vue"; // 编辑器蒙层
import bgSettingBtn from "./tool/bgSettingBtn";
import auxiliaryLine from "./tool/auxiliaryLine";

export default {
  data() {
    return {
      showTextbox: true,
      zIndex: 0,
      text: "",
      textStyle: {},
      autoDraw: false, // 判断autodraw开启关闭
      brushCursor: false // 鼠标是否变成格式刷样式
    };
  },
  computed: {
    ...mapGetters(["TOOL", "Tool_Size", "MaterialPane_Size"]),
    ...mapGetters({
      openSubtitle: "subtitle/openSubtitle",
    })
  },
  mounted() {
    this.$bus.on("showTextbox", data => {
      this.showTextbox = data;
    });
    this.$bus.on("drawing_vue", data => {
      // 打开autodraw
      switch (data.type) {
        case "draw":
          this.autoDraw = true;
          this.TOOL.selectSprite();
          break;
        case "tool":
          this.autoDraw = false;
          break;
        default:
          this.autoDraw = false;
          break;
      }
    });
    this.$bus.on("format-brush-status", data => {
      // 格式刷事件
      if (data.status === "push") {
        this.brushCursor = true;
      } else {
        this.brushCursor = false;
      }
    });
  },
  methods: {
  },
  components: {
    Editor,
    Textbox,
    richText,
    Timeline,
    editorBtn,
    spriteBtn,
    toolMask,
    bgSettingBtn,
    auxiliaryLine
  }
};
</script>

<style scoped lang="scss">
.Tool {
  position: absolute;
  top: 100px;
  z-index: 5;
  transition: all 0.3s;
  &:focus {
    border: 0;
    outline: none;
    cursor: default;
    caret-color: transparent;
  }
}
.autoDraw {
  top: 168px !important;
}
.format-painter-active {
  cursor: url(../../static/svg/cursor-brush.png), auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Tool.vue